module.exports = __webpack_public_path__ + "media/images/pic/courses/group-teacher-left-0f9fbd59977811f855b982ce59133cc8.png";